import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueFeather from 'vue-feather';
import { notifyError } from '@/ErrorHandler';

const app = createApp(App)
app.config.errorHandler = (err, instance, info) => {
  console.error(err)
  notifyError('Error in vuejs: ' +  (err as Error).message +
    '; Info: ' + info + '; Stack: ' + (err as Error).stack)
}

if (VueFeather.name !== undefined) {
    app.component(VueFeather.name, VueFeather)
}
router.onError(err => {
  console.error("VueRouter error" + err)
  notifyError('Error in vuejs router: ' +  err.message)
})

app.use(router)
app.mount('#app')
